import * as React from 'react';

interface ILoadingProps {}

export const QueryEmpty = (props: ILoadingProps) => {
  return <div>Empty...</div>;
};
